function formatTimestamp(timestamp) {
  if (!timestamp) {
    return '';
  }
  const now = new Date(timestamp);
  const hours = now.getHours();
  const minutes = now.getMinutes();
  return window.Number.isNaN(hours)
    ? ''
    : `Last Updated at ${hours.toString(10).padStart(2, '0')}:${minutes.toString(10).padStart(2, '0')}`;
}

export default formatTimestamp;
